module.exports = __webpack_public_path__ + "img/tripscpt.24e1d9a2.png";